export const alertsPriorityConstant = {
    ALERTS_PRIORITY_DISPLAY: "ALERTS_PRIORITY_DISPLAY",
}